import { RenameChatbotInput, ListChatbotsOutput } from "@zapier/bff";
import { trpc } from "../trpc";

type QueryChatbotsCache = ListChatbotsOutput | undefined;

const updateChatbotInListResults = (
  cache: QueryChatbotsCache,
  { id, name }: RenameChatbotInput,
): QueryChatbotsCache => {
  if (!cache?.data) {
    return cache;
  }

  return {
    ...cache,
    data: cache.data.map((chatbot) =>
      chatbot.id === id ? { ...chatbot, name } : chatbot,
    ),
  };
};

interface Input {
  folderId?: string;
}

export const useRenameChatbot = (input?: Input) => {
  const { folderId } = input || {};
  const utils = trpc.useUtils();

  const mutation = trpc.chatbot.rename.useMutation({
    onMutate: (variables) => {
      utils.chatbot.list.cancel();

      utils.chatbot.list.setQueriesData(
        {},
        { exact: false },
        (cache: QueryChatbotsCache) =>
          updateChatbotInListResults(cache, variables),
      );

      utils.chatbot.get.setData({ id: variables.id }, (cache) => {
        return cache
          ? {
              ...cache,
              name: variables.name,
            }
          : cache;
      });

      utils.chatbot.meta.setData({ id: variables.id }, (cache) => {
        return cache
          ? {
              ...cache,
              name: variables.name,
            }
          : cache;
      });
    },
    onSettled: (_data, _error, variables) => {
      utils.chatbot.list.invalidate();

      if (variables?.id) {
        utils.chatbot.get.invalidate({ id: variables.id });
        utils.chatbot.meta.invalidate({ id: variables.id });
      }

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({ folderId });
      }
    },
  });

  return {
    rename: mutation.mutate,
    isLoading: mutation.isPending,
  };
};
